import type { Payment } from '@coreledger/shared-types';
import { api } from './client';

export const paymentsApi = {
  list: () => api.get<Payment[]>('/payments'),
  byInvoice: (invoiceId: string) => api.get<Payment[]>(`/invoices/${invoiceId}/payments`),
  create: (data: Partial<Payment>) =>
    api.post<Payment>(`/invoices/${data.invoiceId}/payments`, data),
  delete: (invoiceId: string, id: string) =>
    api.delete<{ success: boolean }>(`/invoices/${invoiceId}/payments/${id}`),
};
